const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  document.addEventListener('click', (e) => {
    const postBoxes = document.querySelectorAll('.card-overlay.true a');

    Array.from(postBoxes).forEach((postBox) => {
      if (e.target === postBox || postBox.contains(e.target)) {
        e.preventDefault();

        postBox
          .closest('.wp-block-deepsea-column.company-card')
          .nextElementSibling.classList.add('active');
      }
    });

    if (
      e.target.classList.contains('card-overlay-close') ||
      e.target.closest('.card-overlay-close') !== null ||
      e.target.classList.contains('overlay-close')
    ) {
      e.target.closest('.card-dynamic-overlay').classList.remove('active');
    }
  });
});

// Handle display first Founder story item as hero
const founderStoryHero = document.querySelectorAll('.founder-story--item-hero-desktop');
const handleFounderStoryHero = (heroItem) => {
  const carouselWrapper = heroItem.closest('.card-carousel-wrapper');
  const founderStoryHeroWrapper = document.createElement('div');
  founderStoryHeroWrapper.classList.add('wp-block-deepsea-columns', 'founder-story-hero--desktop');
  founderStoryHeroWrapper.appendChild(heroItem);
  carouselWrapper.parentNode.insertBefore(founderStoryHeroWrapper, carouselWrapper);
};

if (founderStoryHero.length > 0) {
  Array.from(founderStoryHero).forEach((item) => {
    handleFounderStoryHero(item);
  });
}
